import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { Endpoints } from 'src/environments/endpoints';
import { BBVAChanPaymentMethodMock } from 'src/mocks/bbvaMocks';
import { SpinnerNames } from '../constants/spinners';
import { ChangedMethodResponse, TransactionDetailStatusResponse } from '../model/http/bbva.model';
import { BaseResponseHttp } from '../model/http/commons.model';
import { ActiveOrdersResponse } from '../model/http/timeline.model';
import { ConsumeService } from './consume.service';

@Injectable({
  providedIn: 'root',
})
export class OrdersService {
  constructor(private consumeService: ConsumeService) { }

  getDeliveredOrders(
    cardCode: string,
    offset: number,
    limit: number,
    userRole: string,
    line: string,
    clientType: string
  ): Observable<ActiveOrdersResponse> {
    return this.consumeService.httpGet<ActiveOrdersResponse>(
      `${Endpoints.orders.delivered}?cardCode=${cardCode}&offset=${offset}&limit=${limit}` +
      `&userRole=${userRole}&line=${line}&clientType=${clientType}`,
      null,
      null,
      SpinnerNames.generalList
    );
  }

  selectMethodToBBVA(orderList: string[]): Observable<BaseResponseHttp> {
    return this.consumeService.httpPost(Endpoints.bbva.selectOrderToChange, orderList);
  }

  getDetail(transactionId: string): Observable<ChangedMethodResponse> {
    return this.consumeService.httpGet(`${Endpoints.bbva.getOrderChangedDetail}/${transactionId}/request`);
  }

  getTransactionStatus(req: string[]): Observable<TransactionDetailStatusResponse> {
    return this.consumeService.httpPost(Endpoints.orders.detailTransaction, req);
  }
}
